import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { XMarkIcon } from './icons';

interface QRCodeModalProps {
  url: string;
  isOpen: boolean;
  onClose: () => void;
}

export default function QRCodeModal({ url, isOpen, onClose }: QRCodeModalProps) {
  const [qrDataUrl, setQrDataUrl] = useState<string>('');

  useEffect(() => {
    if (isOpen && url) {
      QRCode.toDataURL(url, {
        width: 256,
        margin: 2,
        color: {
          dark: '#1e3a5f',
          light: '#ffffff',
        },
      }).then(setQrDataUrl);
    }
  }, [isOpen, url]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-sm w-full p-6 animate-fade-in">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">Scan to Join</h3>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
          >
            <XMarkIcon className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="flex flex-col items-center">
          {qrDataUrl && (
            <img src={qrDataUrl} alt="QR Code" className="w-48 h-48 rounded-lg" />
          )}
          <p className="mt-4 text-sm text-gray-500 text-center">
            Scan this code with your phone's camera to join this clip
          </p>
        </div>
      </div>
    </div>
  );
}
